/*
Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const TableColumnRemoveCenterIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Table Column Remove Center',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden="${hidden ? 'true' : 'false'}"
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M8.1 27a8.9 8.9 0 108.9-8.9A8.9 8.9 0 008.1 27zm3.9-.5a.5.5 0 01.5-.5h9a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5z"
    />
    <path
      d="M33 2H1a1 1 0 00-1 1v30a1 1 0 001 1h5.893a12.139 12.139 0 01-1.123-2H2v-8h3.084a12.139 12.139 0 01.684-2H2v-8h8v3.308a12.229 12.229 0 014-1.808V6h6v9.5a12.229 12.229 0 014 1.809V14h8v8h-3.768a12.139 12.139 0 01.684 2H32v8h-3.769a12.139 12.139 0 01-1.123 2H33a1 1 0 001-1V3a1 1 0 00-1-1zM10 12H2V4h8zm22 0h-8V4h8z"
    />
  </svg>`;
};
